<div class="container-fluid" style="padding: 0;">

  <div class="col-12">
    <div class="static-content">
      <div [innerHTML]="docContent | safeHtml"></div>
    </div>
  </div>
</div>
